import React, { Component } from 'react';
import '../css/dataTables.css';
import $ from 'jquery';
import { getFieldAccType } from '../libs/utils/Operations';
import AccountListModal from './AccountListModal';

class ItemsGroupCodeModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            partners: [],
        };
    };

    componentDidMount = async () => {

    };

    closeModalCreate = async () => {
        const { action, CloseDocumentModal } = this.props;
        // if (action === 1) {
        //     $('#confirmModal').modal('show');
        // } else {
        $('#itemsGroupCodeModal').modal('hide');
        await CloseDocumentModal();
        // }
    };

    renderEditButton = () => {
        const { action, editMode, changeEditModeGroupCode } = this.props;

        if (action === 2 && !editMode) {
            return (
                <button
                    type="button"
                    style={{ backgroundColor: 'transparent', color: '#000' }}
                    className="btn btn-editar"
                    onClick={changeEditModeGroupCode}>
                    <i className="fas fa-edit  fa-lg" />
                    Editar
                </button>
            );
        }
    };

    sendModel = () => {
        const { newGroupCodeModel, SendNewGroupCode, showAlert } = this.props;
        if (newGroupCodeModel.ItmsGrpNam === '') {
            showAlert({ type: 'error', message: 'El campo nombre de grupo de artículos no puede ir vacío.' }, 5000);
            return;
        }

        if (newGroupCodeModel.BalInvntAc === '') {
            showAlert({ type: 'error', message: 'En finanzas el campo "Cuenta de existencias" no puede ir vacío.' });
            return;
        }

        if (newGroupCodeModel.PriceDifAc === '') {
            showAlert({ type: 'error', message: 'En finanzas el campo "Cuenta de diferencias de precio" no puede ir vacío.' });
            return;
        }
        SendNewGroupCode(newGroupCodeModel);
    };

    refreshModel = newGroupCodeModel => {
        const { refreshModel } = this.props;
        refreshModel(newGroupCodeModel);
    };

    change_ItmsGrpNam = async (event) => {
        const { newGroupCodeModel } = this.props;

        if (event.nativeEvent.data !== '') {
            newGroupCodeModel.ItmsGrpNam = event.nativeEvent.target.value;
        }
        this.refreshModel(newGroupCodeModel);
    };

    validateItmsGrpNam = async () => {
        const { newGroupCodeModel, showAlert } = this.props;
        if (newGroupCodeModel.ItmsGrpNam === '') {
            showAlert({ type: 'error', message: 'El campo nombre de grupo de artículos no puede ir vacío.' }, 5000);
            return;
        }
    };

    change_UgpEntry = async (event) => {
        const { newGroupCodeModel } = this.props;

        if (event.nativeEvent.data !== '') {
            newGroupCodeModel.UgpEntry = event.nativeEvent.target.value;
        }
        this.refreshModel(newGroupCodeModel);
    };

    change_PlaningSys = async (event) => {
        const { newGroupCodeModel } = this.props;

        if (event.nativeEvent.data !== '') {
            newGroupCodeModel.PlaningSys = event.nativeEvent.target.value;
        }
        this.refreshModel(newGroupCodeModel);
    };

    change_PrcrmntMtd = async (event) => {
        const { newGroupCodeModel } = this.props;

        if (event.nativeEvent.data !== '') {
            newGroupCodeModel.PrcrmntMtd = event.nativeEvent.target.value;
            if (newGroupCodeModel.PrcrmntMtd === 'B') {
                newGroupCodeModel.CompoWH = 'B';
            }
        }
        this.refreshModel(newGroupCodeModel);
    };

    change_CompoWH = async (event) => {
        const { newGroupCodeModel } = this.props;

        if (event.nativeEvent.data !== '') {
            newGroupCodeModel.CompoWH = event.nativeEvent.target.value;
        }
        this.refreshModel(newGroupCodeModel);
    };

    change_OrdrIntrvl = async (event) => {
        const { newGroupCodeModel } = this.props;

        if (event.nativeEvent.data !== '') {
            newGroupCodeModel.OrdrIntrvl = event.nativeEvent.target.value;
        }
        this.refreshModel(newGroupCodeModel);
    };

    change_OrdrMulti = async (event) => {
        const { newGroupCodeModel } = this.props;
        let value = event.nativeEvent.target.value;

        if (value.length > 10) {
            value = value.slice(0, 10);
        }

        if (event.nativeEvent.data !== '') {
            newGroupCodeModel.OrdrMulti = value;
        }
        this.refreshModel(newGroupCodeModel);
    };

    format_OrdrMulti = () => {
        const { newGroupCodeModel } = this.props;
        const value = parseFloat(newGroupCodeModel.OrdrMulti);
        if (!isNaN(value)) {
            newGroupCodeModel.OrdrMulti = value.toFixed(3);
            this.refreshModel(newGroupCodeModel);
        }
    };

    change_MinOrdrQty = async (event) => {
        const { newGroupCodeModel } = this.props;
        let value = event.nativeEvent.target.value;

        if (value.length > 10) {
            value = value.slice(0, 10);
        }

        if (value !== '') {
            newGroupCodeModel.MinOrdrQty = value;
        }
        this.refreshModel(newGroupCodeModel);
    };

    format_MinOrdrQty = async (event) => {
        const { newGroupCodeModel } = this.props;
        const value = parseFloat(newGroupCodeModel.MinOrdrQty);
        if (!isNaN(value)) {
            newGroupCodeModel.MinOrdrQty = value.toFixed(3);
            this.refreshModel(newGroupCodeModel);
        }
    };

    change_RuleCode = async (event) => {
        const { newGroupCodeModel } = this.props;

        if (event.nativeEvent.data !== '') {
            newGroupCodeModel.RuleCode = event.nativeEvent.target.value;
        }
        this.refreshModel(newGroupCodeModel);
    };

    change_LeadTime = async (event) => {
        const { newGroupCodeModel } = this.props;

        if (event.nativeEvent.data !== '') {
            newGroupCodeModel.LeadTime = event.nativeEvent.target.value;
        }
        this.refreshModel(newGroupCodeModel);
    };

    change_ToleranDay = async (event) => {
        const { newGroupCodeModel } = this.props;

        if (event.nativeEvent.data !== '') {
            newGroupCodeModel.ToleranDay = event.nativeEvent.target.value;
        }
        this.refreshModel(newGroupCodeModel);
    };

    change_InvntSys = async (event) => {
        const { newGroupCodeModel } = this.props;

        if (event.nativeEvent.data !== '') {
            newGroupCodeModel.InvntSys = event.nativeEvent.target.value;
        }
        this.refreshModel(newGroupCodeModel);
    };

    // FINANZAS
    change_Account = async (index, event) => {
        const { newGroupCodeModel } = this.props;

        if (event.nativeEvent.data !== '') {
            newGroupCodeModel.ListAccounts[index].Account = event.nativeEvent.target.value;
        }
        this.refreshModel(newGroupCodeModel);
    };

    handleOnChange = (property, value) => {
        const { newGroupCodeModel, refreshModel } = this.props

        // if (this.disableEdition(property)) return

        const auxModel = { ...newGroupCodeModel }

        auxModel[property] = value;
        refreshModel(auxModel)
    };

    renderInput = (property, value, label, title = '', btnAction = null) => {
        const { action, editMode } = this.props;
        // const disableInput = this.disableEdition(property)
        return (
            <div title={title || ''} className="input-group mb-3 align-items-center">
                {label !== '' && <div className="input-group-prepend">
                    <span className="input-group-text font-weight-bold">
                        {label}
                    </span>
                </div>
                }

                <input
                    disabled={action === 2 && !editMode ? true : false}
                    type="text"
                    className="form-control input-sm"
                    id="dynInput"
                    value={value}
                    onChange={(e) => this.handleOnChange(property, e.target.value)}
                />
                {btnAction &&

                    <div className="input-group-append">
                        <button
                            type="button"
                            disabled={action === 2 && !editMode ? true : false}
                            className="input-group-text"
                            style={{
                                width: '40px',
                                height: '38px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'transparent',
                                color: '#EABF28',
                                border: '1px solid #ced4da',
                                borderLeft: 'none'
                            }}
                            onClick={btnAction}>
                            <i className="fa fa-list" aria-hidden="true" />
                        </button>
                    </div>
                }
            </div>
        )
    };

    listAccount = async (field) => {
        const { newGroupCodeModel, listCounts } = this.props
        const data = {
            Search: newGroupCodeModel[field],
            AccType: getFieldAccType(field)
        }

        await listCounts(field, data);
    };

    ClearModel = async () => {
        const { newGroupCode } = this.props;
        await newGroupCode();
    };

    sendModelEdit = () => {
        const { newGroupCodeModel, UpdateGroupCode, showAlert } = this.props;
        if (newGroupCodeModel.ItmsGrpNam === '') {
            showAlert({ type: 'error', message: 'El campo nombre de grupo de artículos no puede ir vacío.' }, 5000);
            return;
        }

        if (newGroupCodeModel.BalInvntAc === '') {
            showAlert({ type: 'error', message: 'En finanzas el campo "Cuenta de existencias" no puede ir vacío.' });
            return;
        }

        if (newGroupCodeModel.PriceDifAc === '') {
            showAlert({ type: 'error', message: 'En finanzas el campo "Cuenta de diferencias de precio" no puede ir vacío.' });
            return;
        }

        UpdateGroupCode(newGroupCodeModel);
    };

    selectAccountList = indexAcc => {
        const { listAccounts, cleanData } = this.props;
        if (listAccounts[indexAcc.index].AcctCode) {
            $('#AccountListModal').modal('hide');
            this.handleOnChange(this.props.fieldUsed, listAccounts[indexAcc.index].AcctCode)
            cleanData()
            // this.setState({
            //     listAccounts: [],
            //     showListAccountsModal: false,
            //     fieldUsed: ''
            // })
        }
    }

    render() {
        const { action, newGroupCodeModel, ListUgpCodes, ListOrdrIntrvl, editMode, showListAccountsModal, listAccounts, cleanData } = this.props;

        return (
            <div className="modal fade bd-example-modal-md modal-open scroll"
                id="itemsGroupCodeModal"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
                style={{ zIndex: 90 }}>

                {/* <ConfirmModal
                    CloseDocumentModal={CloseDocumentModal} /> */}

                {showListAccountsModal &&
                    <AccountListModal
                        data={listAccounts}
                        selectAccount={this.selectAccountList}
                        cleanData={() => cleanData()}
                    />
                }

                <div className="modal-dialog modal-lg modal-open modalOrder" role="document">
                    <div className="modal-content" id="printThis">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">
                                Grupos de Artículos
                            </h4>
                            <button type="button" className="close" onClick={this.closeModalCreate} aria-label="Close">
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>

                        <div className="modal-body" >
                            <div className="container">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        {(true) &&
                                            <button className="btn botonCorrect text-black"
                                                onClick={this.ClearModel} style={{ marginBottom: 10 }}>
                                                <i className="fas fa-plus"></i> Crear Nuevo
                                            </button>
                                        }
                                        {this.renderEditButton()}
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre de grupo de artículos</span>
                                            </div>
                                            <input type="text" className="form-control" id="txtItmsGrpNam" autoComplete="off"
                                                disabled={action === 2 ? true : false}
                                                onKeyDown={(ev) => {
                                                    if (ev.key === 'Tab') {
                                                        this.validateItmsGrpNam();
                                                    }
                                                }}
                                                // onBlur={() => this.validateItmsGrpNam()}
                                                onChange={this.change_ItmsGrpNam}
                                                value={newGroupCodeModel.ItmsGrpNam ? newGroupCodeModel.ItmsGrpNam : ''} />
                                        </div>
                                        <br></br>

                                        <nav>
                                            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                                <a
                                                    className="nav-item nav-link font-weight-bold text-secondary active"
                                                    id="nav-profile-tab-datosGeneral-Inventory"
                                                    data-toggle="tab"
                                                    href="#datosGeneral"
                                                    role="tab"
                                                    aria-controls="datosGeneral"
                                                    aria-selected="true">
                                                    General
                                                </a>
                                                <a
                                                    className="nav-item nav-link font-weight-bold text-secondary"
                                                    id="nav-profile-tab-datosCompras-Inventory"
                                                    data-toggle="tab"
                                                    href="#datosFinanzas"
                                                    role="tab"
                                                    aria-controls="datosFinanzas"
                                                    aria-selected="false">
                                                    Finanzas
                                                </a>
                                            </div>
                                        </nav>

                                        <div className="tab-content" style={{ textAlign: 'left' }}>
                                            {/* GENERAL */}
                                            <div className="container tab-pane active"
                                                id="datosGeneral"
                                                role="datosGeneral"
                                                aria-labelledby="nav-profile-tab-General"
                                            >
                                                <div className="col-12 col-md-6"><br></br>
                                                    {/* Grupo de unidades de medida */}
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Grupo de unidades de medida</span>
                                                        </div>
                                                        <select name="select" className="form-control btn-outline-secondary" id="selectUgpEntry"
                                                            style={{ color: "#000", borderRadius: 4, backgroundColor: action === 2 && !editMode ? "#e9ecef" : "transparent", height: 40 }}
                                                            value={newGroupCodeModel.UgpEntry}
                                                            disabled={action === 2 && !editMode ? true : false}
                                                            onChange={(event) => this.change_UgpEntry(event)}
                                                        >
                                                            <option value=""></option>
                                                            {!!ListUgpCodes && ListUgpCodes.map((item, index) => {
                                                                return (<option key={item.UgpEntry} value={item.UgpEntry}>{item.UgpCode}</option>)
                                                            })}
                                                        </select>
                                                    </div>
                                                    {/* Método de planificación */}
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Método de planificación</span>
                                                        </div>
                                                        <select name="select" className="form-control btn-outline-secondary" id="selectPlaningSys"
                                                            style={{ color: "#000", borderRadius: 4, backgroundColor: action === 2 && !editMode ? "#e9ecef" : "transparent", height: 40 }}
                                                            value={newGroupCodeModel.PlaningSys}
                                                            disabled={action === 2 && !editMode ? true : false}
                                                            onChange={(event) => this.change_PlaningSys(event)}
                                                        >
                                                            <option value="M">PNM</option>
                                                            <option value="N">Ning.</option>
                                                        </select>
                                                    </div>
                                                    {/* Método abastecimiento */}
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Método abastecimiento</span>
                                                        </div>
                                                        <select name="select" className="form-control btn-outline-secondary" id="selectPrcrmntMtd"
                                                            style={{ color: "#000", borderRadius: 4, backgroundColor: action === 2 && !editMode ? "#e9ecef" : "transparent", height: 40 }}
                                                            value={newGroupCodeModel.PrcrmntMtd}
                                                            disabled={action === 2 && !editMode ? true : false}
                                                            onChange={(event) => this.change_PrcrmntMtd(event)}
                                                        >
                                                            <option value="B">Comprar</option>
                                                            <option value="M">Efectuar</option>
                                                        </select>
                                                    </div>
                                                    {/* Almacén de componentes */}
                                                    {newGroupCodeModel.PrcrmntMtd === 'M' &&
                                                        <div className="input-group mb-3">
                                                            <div className="input-group-prepend">
                                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Almacén de componentes</span>
                                                            </div>
                                                            <select name="select" className="form-control btn-outline-secondary" id="selectCompoWH"
                                                                style={{ color: "#000", borderRadius: 4, backgroundColor: action === 2 && !editMode ? "#e9ecef" : "transparent", height: 40 }}
                                                                value={newGroupCodeModel.CompoWH}
                                                                disabled={action === 2 && !editMode ? true : false}
                                                                onChange={(event) => this.change_CompoWH(event)}
                                                            >
                                                                <option value="B">De línea de lista de materiales</option>
                                                                <option value="P">De línea de documento de artículo de nivel superior</option>
                                                            </select>
                                                        </div>
                                                    }
                                                    {/* Intervalo pedido */}
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Intervalo pedido</span>
                                                        </div>
                                                        <select name="select" className="form-control btn-outline-secondary" id="selectOrdrIntrvl"
                                                            style={{ color: "#000", borderRadius: 4, backgroundColor: action === 2 && !editMode ? "#e9ecef" : "transparent", height: 40 }}
                                                            value={newGroupCodeModel.OrdrIntrvl}
                                                            disabled={action === 2 && !editMode ? true : false}
                                                            onChange={(event) => this.change_OrdrIntrvl(event)}
                                                        >
                                                            <option value=""></option>
                                                            {!!ListOrdrIntrvl && ListOrdrIntrvl.map((item, index) => {
                                                                return (<option key={item.Code} value={item.Code}>{item.Name}</option>)
                                                            })}
                                                        </select>
                                                    </div>
                                                    {/* Pedido múltiple */}
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Pedido múltiple</span>
                                                        </div>
                                                        <input type="number" className="form-control" id="txtOrdrMulti" autoComplete="on"
                                                            disabled={action === 2 && !editMode ? true : false}
                                                            onChange={this.change_OrdrMulti}
                                                            onBlur={this.format_OrdrMulti}
                                                            value={newGroupCodeModel.OrdrMulti ? newGroupCodeModel.OrdrMulti : ''} />
                                                    </div>
                                                    {/* Cantidad de pedido mínima */}
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Cantidad de pedido mínima</span>
                                                        </div>
                                                        <input type="number" className="form-control" id="txtMinOrdrQty" autoComplete="on"
                                                            disabled={action === 2 && !editMode ? true : false}
                                                            onChange={this.change_MinOrdrQty}
                                                            onBlur={this.format_MinOrdrQty}
                                                            value={newGroupCodeModel.MinOrdrQty ? newGroupCodeModel.MinOrdrQty : ''} />
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Unidad de medida de inv</span>
                                                        </div>
                                                    </div>
                                                    {/* NO ENCONTRE EL CAMPO EN EL JSON DE SERVICE LAYER :'(  */}
                                                    {/* Regla de verificación */}
                                                    {/* <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Regla de verificación</span>
                                                        </div>
                                                        <input type="text" className="form-control" id="txtRuleCode" autoComplete="on"
                                                            disabled={action === 2 && !editMode ? true : false}
                                                            onChange={this.change_RuleCode}
                                                            value={newGroupCodeModel.RuleCode ? newGroupCodeModel.RuleCode : ''} />
                                                    </div> */}
                                                    {/* Tiempo de entrega */}
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Tiempo de entrega</span>
                                                        </div>
                                                        <input type="text" className="form-control" id="txtLeadTime" autoComplete="on"
                                                            disabled={action === 2 && !editMode ? true : false}
                                                            onChange={this.change_LeadTime}
                                                            value={newGroupCodeModel.LeadTime ? newGroupCodeModel.LeadTime : ''} />
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Días</span>
                                                        </div>
                                                    </div>
                                                    {/* Días de tolerancia */}
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Días de tolerancia</span>
                                                        </div>
                                                        <input type="text" className="form-control" id="txtToleranDay" autoComplete="on"
                                                            disabled={action === 2 && !editMode ? true : false}
                                                            onChange={this.change_ToleranDay}
                                                            value={newGroupCodeModel.ToleranDay ? newGroupCodeModel.ToleranDay : ''} />
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Días</span>
                                                        </div>
                                                    </div>
                                                    <br></br>
                                                    <br></br>
                                                    {/* Método estándar de valoración */}
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Método estándar de valoración</span>
                                                        </div>
                                                        <select name="select" className="form-control btn-outline-secondary" id="selectInvntSys"
                                                            style={{ color: "#000", borderRadius: 4, backgroundColor: action === 2 && !editMode ? "#e9ecef" : "transparent", height: 40 }}
                                                            value={newGroupCodeModel.InvntSys}
                                                            disabled={action === 2 && !editMode ? true : false}
                                                            onChange={(event) => this.change_InvntSys(event)}
                                                        >
                                                            <option value="A">Promedio ponderado</option>
                                                            <option value="S">Estándar</option>
                                                            <option value="F">FIFO</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* FINANZAS */}
                                            <div className="container tab-pane fade"
                                                id="datosFinanzas"
                                                role="datoscontactperson"
                                                aria-labelledby="nav-profile-tab-ContactPerson"
                                            //  style={{maxHeight: 700}}
                                            >
                                                <div className="row col-sm col" style={{ paddingRight: 0, maxHeight: '550px', overflowY: 'auto', paddingTop: 15 }}>
                                                    {this.renderInput('ExpensesAc', newGroupCodeModel?.ExpensesAc || '', 'Cta. gastos', 'Cuenta de gastos', () => { this.listAccount('ExpensesAc') })}
                                                    {this.renderInput('RevenuesAc', newGroupCodeModel?.RevenuesAc || '', 'Cta. ingresos', 'Cuenta de ingresos', () => { this.listAccount('RevenuesAc') })}
                                                    {this.renderInput('BalInvntAc', newGroupCodeModel?.BalInvntAc || '', 'Cta. existencias', 'Cuenta de existencias', () => { this.listAccount('BalInvntAc') })}
                                                    {this.renderInput('SaleCostAc', newGroupCodeModel?.SaleCostAc || '', 'Cta. costo de bienes ven.', 'Cuenta de costo de bienes vendidos', () => { this.listAccount('SaleCostAc') })}
                                                    {this.renderInput('TransferAc', newGroupCodeModel?.TransferAc || '', 'Cta. dotación', 'Cuenta de dotación', () => { this.listAccount('TransferAc') })}
                                                    {this.renderInput('VarianceAc', newGroupCodeModel?.VarianceAc || '', 'Cta. desviación', 'Cuenta de desviación', () => { this.listAccount('VarianceAc') })}
                                                    {this.renderInput('PriceDifAc', newGroupCodeModel?.PriceDifAc || '', 'Cta. dif. precio', 'Cuenta de diferencias de precio', () => { this.listAccount('PriceDifAc') })}
                                                    {this.renderInput('NegStckAct', newGroupCodeModel?.NegStckAct || '', 'Cta. ajuste de stock neg.', 'Cuenta de ajuste de stock negativo', () => { this.listAccount('NegStckAct') })}
                                                    {this.renderInput('DecreasAc', newGroupCodeModel?.DecreasAc || '', 'Comp. stocks - Cta. reducción', 'Compensación de stocks - Cuenta de reducción', () => { this.listAccount('DecreasAc') })}
                                                    {this.renderInput('IncreasAc', newGroupCodeModel?.IncreasAc || '', 'Comp. stocks - Cta. aumento', 'Compensación de stocks - Cuenta de aumento', () => { this.listAccount('IncreasAc') })}
                                                    {this.renderInput('ReturnAc', newGroupCodeModel?.ReturnAc || '', 'Cta. devoluciones por ventas', 'Cuenta de devoluciones por ventas', () => { this.listAccount('ReturnAc') })}
                                                    {this.renderInput('FrRevenuAc', newGroupCodeModel?.FrRevenuAc || '', 'Cta. ingresos - Extranjero', 'Cuenta de ingresos - Extranjero', () => { this.listAccount('FrRevenuAc') })}
                                                    {this.renderInput('FrExpensAc', newGroupCodeModel?.FrExpensAc || '', 'Cta. costos - Extranjero', 'Cuenta de costos - Extranjero', () => { this.listAccount('FrExpensAc') })}
                                                    {this.renderInput('ExchangeAc', newGroupCodeModel?.ExchangeAc || '', 'Cta. dif. tipo de cambio', 'Cuenta de diferencias de tipo de cambio', () => { this.listAccount('ExchangeAc') })}
                                                    {this.renderInput('BalanceAcc', newGroupCodeModel?.BalanceAcc || '', 'Cuenta comp. mercancías', 'Cuenta compensación mercancías', () => { this.listAccount('BalanceAcc') })}
                                                    {this.renderInput('DecresGlAc', newGroupCodeModel?.DecresGlAc || '', 'Cta. reducción del libro mayor', 'Cuenta de reducción del libro mayor', () => { this.listAccount('DecresGlAc') })}

                                                    {this.renderInput('IncresGlAc', newGroupCodeModel?.IncresGlAc || '', 'Cta. aumento del libro mayor', 'Cuenta de aumento del libro mayor', () => { this.listAccount('IncresGlAc') })}
                                                    {this.renderInput('WipAcct', newGroupCodeModel?.WipAcct || '', 'Cta. stocks trabajo curso', 'Cuenta de stocks de trabajo en curso', () => { this.listAccount('WipAcct') })}
                                                    {this.renderInput('WipVarAcct', newGroupCodeModel?.WipVarAcct || '', 'Cta. desviación de stock WIP', 'Cuenta de desviación de stock WIP', () => { this.listAccount('WipVarAcct') })}
                                                    {this.renderInput('WipOffset', newGroupCodeModel?.WipOffset || '', 'Cta. PyG de comp. WIP', 'Cuenta PyG de compensación WIP', () => { this.listAccount('WipOffset') })}
                                                    {this.renderInput('StockOffst', newGroupCodeModel?.StockOffst || '', 'Cta. PyG de comp. de stocks', 'Cuenta PyG de compensación de stocks', () => { this.listAccount('StockOffst') })}
                                                    {this.renderInput('StokRvlAct', newGroupCodeModel?.StokRvlAct || '', 'Cta. de revalorización de stocks', 'Cuenta de revalorización de stocks', () => { this.listAccount('StokRvlAct') })}
                                                    {this.renderInput('StkOffsAct', newGroupCodeModel?.StkOffsAct || '', 'Cta. contrapartida de rev. inventario', 'Cuenta de contrapartida de la revalorización del inventario', () => { this.listAccount('StkOffsAct') })}
                                                    {this.renderInput('CostRvlAct', newGroupCodeModel?.CostRvlAct || '', 'Cta. revaloración precio costo', 'Cuenta revaloración precio costo', () => { this.listAccount('CostRvlAct') })}
                                                    {this.renderInput('CstOffsAct', newGroupCodeModel?.CstOffsAct || '', 'Rev. precio de costo - Cta. contrapartida', 'Revaloración precio de costo - Cuenta de contrapartida', () => { this.listAccount('CstOffsAct') })}
                                                    {this.renderInput('ExpClrAct', newGroupCodeModel?.ExpClrAct || '', 'Cta. comp. gastos', 'Cuenta compensación gastos', () => { this.listAccount('ExpClrAct') })}
                                                    {this.renderInput('StkInTnAct', newGroupCodeModel?.StkInTnAct || '', 'Stock en cta. tránsito', 'Stock en la cuenta de tránsito', () => { this.listAccount('StkInTnAct') })}
                                                    {this.renderInput('ShpdGdsAct', newGroupCodeModel?.ShpdGdsAct || '', 'Cta. mercancías enviadas', 'Cuenta de mercancías enviadas', () => { this.listAccount('ShpdGdsAct') })}
                                                    {this.renderInput('ARCMAct', newGroupCodeModel?.ARCMAct || '', 'Cta.crédito ventas', 'Cta.crédito ventas', () => { this.listAccount('ARCMAct') })}
                                                    {this.renderInput('APCMAct', newGroupCodeModel?.APCMAct || '', 'Cta.crédito compras', 'Cta.crédito compras', () => { this.listAccount('APCMAct') })}
                                                    {this.renderInput('ARCMFrnAct', newGroupCodeModel?.ARCMFrnAct || '', 'Cta.crédito ventas: Extranjero', 'Cta.crédito ventas: Extranjero', () => { this.listAccount('ARCMFrnAct') })}
                                                    {this.renderInput('APCMFrnAct', newGroupCodeModel?.APCMFrnAct || '', 'Cta.crédito compras - Extranjero', 'Cta.crédito compras - Extranjero', () => { this.listAccount('APCMFrnAct') })}

                                                    {/* <table
                                                        className="display table-hover"
                                                        style={{ width: '100%', marginBottom: 40, marginRight: -3000 }}>
                                                        <thead className="table-header-yellow">
                                                            <tr style={{ textAlign: "center" }}>
                                                                <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                                                    #
                                                                </td>
                                                                <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                                                    Código de cuenta
                                                                </td>
                                                                <td className="sticky-header" style={{ backgroundColor: '#d2ab24' }}>
                                                                    Nombre de cuenta
                                                                </td>
                                                            </tr>
                                                        </thead>
                                                        list =  [
                                                                    { Code: 1, Name: 'Cuenta de gastos', userfield: 'ExpensesAc', Account: '', NameAcct: '' }
                                                                    , { Code: 2, Name: 'Cuenta de ingresos', userfield: 'RevenuesAc', Account: '', NameAcct: '' }
                                                                    , { Code: 3, Name: 'Cuenta de existencias', userfield: 'BalInvntAc', Account: '', NameAcct: '' }
                                                                    , { Code: 4, Name: 'Cuenta de costo de bienes vendidos', userfield: 'SaleCostAc', Account: '', NameAcct: '' }
                                                                    , { Code: 5, Name: 'Cuenta de dotación', userfield: 'TransferAc', Account: '', NameAcct: '' }
                                                                    , { Code: 6, Name: 'Cuenta de desviación', userfield: 'VarianceAc', Account: '', NameAcct: '' }
                                                                    , { Code: 7, Name: 'Cuenta de diferencias de precio', userfield: 'PriceDifAc', Account: '', NameAcct: '' }
                                                                    , { Code: 8, Name: 'Cuenta de ajuste de stock negativo', userfield: 'NegStckAct', Account: '', NameAcct: '' }
                                                                    , { Code: 9, Name: 'Compensación de stocks - Cuenta de reducción', userfield: 'DecreasAc', Account: '', NameAcct: '' }
                                                                    , { Code: 10, Name: 'Compensación de stocks - Cuenta de aumento', userfield: 'IncreasAc', Account: '', NameAcct: '' }
                                                                    , { Code: 11, Name: 'Cuenta de devoluciones por ventas', userfield: 'ReturnAc', Account: '', NameAcct: '' }
                                                                    , { Code: 12, Name: 'Cuenta de ingresos - Extranjero', userfield: 'FrRevenuAc', Account: '', NameAcct: '' }
                                                                    , { Code: 13, Name: 'Cuenta de costos - Extranjero', userfield: 'FrExpensAc', Account: '', NameAcct: '' }
                                                                    , { Code: 14, Name: 'Cuenta de diferencias de tipo de cambio', userfield: 'ExchangeAc', Account: '', NameAcct: '' }
                                                                    , { Code: 15, Name: 'Cuenta compensación mercancías', userfield: 'BalanceAcc', Account: '', NameAcct: '' }
                                                                    , { Code: 16, Name: 'Cuenta de reducción del libro mayor', userfield: 'DecresGlAc', Account: '', NameAcct: '' }
                                                                    , { Code: 17, Name: 'Cuenta de aumento del libro mayor', userfield: 'IncresGlAc', Account: '', NameAcct: '' }
                                                                    , { Code: 18, Name: 'Cuenta de stocks de trabajo en curso', userfield: 'WipAcct', Account: '', NameAcct: '' }
                                                                    , { Code: 19, Name: 'Cuenta de desviación de stock WIP', userfield: 'WipVarAcct', Account: '', NameAcct: '' }
                                                                    , { Code: 20, Name: 'Cuenta PyG de compensación WIP', userfield: 'WipOffset', Account: '', NameAcct: '' }
                                                                    , { Code: 21, Name: 'Cuenta PyG de compensación de stocks', userfield: 'StockOffst', Account: '', NameAcct: '' }
                                                                    , { Code: 22, Name: 'Cuenta de revalorización de stocks', userfield: 'StokRvlAct', Account: '', NameAcct: '' }
                                                                    , { Code: 23, Name: 'Cuenta de contrapartida de la revalorización del inventario', userfield: 'StkOffsAct', Account: '', NameAcct: '' }
                                                                    , { Code: 24, Name: 'Cuenta revaloración precio costo', userfield: 'CostRvlAct', Account: '', NameAcct: '' }
                                                                    , { Code: 25, Name: 'Revaloración precio de costo - Cuenta de contrapartida', userfield: 'CstOffsAct', Account: '', NameAcct: '' }
                                                                    , { Code: 26, Name: 'Cuenta compensación gastos', userfield: 'ExpClrAct', Account: '', NameAcct: '' }
                                                                    , { Code: 27, Name: 'Stock en la cuenta de tránsito', userfield: 'StkInTnAct', Account: '', NameAcct: '' }
                                                                    , { Code: 28, Name: 'Cuenta de mercancías enviadas', userfield: 'ShpdGdsAct', Account: '', NameAcct: '' }
                                                                    , { Code: 29, Name: 'Cta.crédito ventas', userfield: 'ARCMAct', Account: '', NameAcct: '' }
                                                                    , { Code: 30, Name: 'Cta.crédito compras', userfield: 'APCMAct', Account: '', NameAcct: '' }
                                                                    , { Code: 31, Name: 'Cta.crédito ventas: Extranjero', userfield: 'ARCMFrnAct', Account: '', NameAcct: '' }
                                                                    , { Code: 32, Name: 'Cta.crédito compras - Extranjero', userfield: 'APCMFrnAct', Account: '', NameAcct: '' }
                                                                ];
                                                        <tbody>
                                                            {!!newGroupCodeModel.ListAccounts && newGroupCodeModel.ListAccounts.map((item, index) => {
                                                                return (
                                                                    <tr style={{
                                                                        maxHeight: 10,
                                                                        paddingTop: 8,
                                                                        paddingBottom: 8
                                                                    }}>
                                                                        <td
                                                                            className="sticky-column"
                                                                            style={{ textAlign: 'left', maxWidth: 800, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', cursor: 'pointer' }} title={item.Name}>
                                                                            {item.Name.length > 35 ? item.Name.substring(0, 35) + '...' : item.Name}
                                                                        </td>
                                                                        <td className="overflow-visible"
                                                                            style={{ textAlign: 'center', maxWidth: 800 }}>
                                                                            <input type="text" className="form-control" id="txtAccount" autoComplete="off"
                                                                                disabled={action === 2 && !editMode ? true : false}
                                                                                key={'txtAccount' + item.Code}
                                                                                onChange={(event) => this.change_Account(index, event)}
                                                                                value={item.Account ? item.Account : ''} />
                                                                        </td>
                                                                        <td
                                                                            className="overflow-visible"
                                                                            style={{ textAlign: 'left', maxWidth: 800, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', cursor: 'pointer' }} title={item.NameAcct}>
                                                                            {item.NameAcct.length > 20 ? item.NameAcct.substring(0, 20) + '...' : item.NameAcct}
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            {/* {(action === 2 && view === 'deliveries' && itemBaseType.length > 0) &&
                                <button
                                    type="button"
                                    className="btn btn-danger text-white "
                                    style={{ position: "absolute", left: "1rem" }}
                                    onClick={this.OpenModalCloseDocuments}>
                                    Cancelar
                                </button>
                            } */}

                            <button
                                type="button"
                                className="btn botonCerrar text-white"
                                onClick={this.closeModalCreate}>
                                Cerrar
                            </button>

                            {Number(action) === 1 && (
                                <button type="button" className="btn botonCorrect text-black" onClick={this.sendModel}>
                                    Crear
                                </button>
                            )}

                            {(Number(action) === 2 && editMode) && (
                                <button type="button" className="btn botonCorrect text-black" onClick={this.sendModelEdit}>
                                    Guardar
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };
}

export default ItemsGroupCodeModal;